import { Box, Flex, FloraButton, styled } from '@grupoboticario/flora-react';
import { Table } from '@grupoboticario/flora-team-react-table';
import { ResponsiveFloraTypography } from 'ui/components';
import { theme } from 'ui/theme';

export const ModalUnavailableItemsStyles = {
  ImgProduct: styled('img', {
    border: `1px solid ${theme.colors.build.lightDark1}`,
  }),
  BoxInfo: styled(Box, {
    width: '100%',
    background: `${theme.colors.build.lightDark2}`,
    padding: `${theme.sizes['4']} ${theme.sizes['7']}`,
    marginBottom: `${theme.sizes['1']}`,
    marginTop: `${theme.sizes['4']}`,
    '@desktop': {
      marginTop: '0px',
    },
  }),
  BoxProduct: styled(Flex, {
    width: '100%',
    background: `${theme.colors.build.lightDark2}`,
    padding: `${theme.sizes['4']} ${theme.sizes['7']}`,
    marginBottom: `${theme.sizes['3']}`,
    '@desktop': {
      marginBottom: `${theme.sizes['4']}`,
    },
  }),
  Button: styled(FloraButton, {
    '&[data-unavaliable]': {
      backgroundColor: 'transparent !important',
      boxShadow: `inset 0 0 0 1px ${theme.colors.action.navigation.standard.static} !important`,
      color: `${theme.colors.action.navigation.standard.static} !important`,
      fontFamily: `${theme.fonts.primary}`,
      marginTop: `${theme.sizes['3']}`,
      borderColor: 'transparent !important',

      '&:hover': {
        background: `${theme.colors.action.navigation.standard.static} !important`,
        color: `${theme.colors.build.lightDark1} !important`,
      },
    },
  }),
  TableHeader: styled(Table.Header, {
    backgroundColor: '$backgroundPrimary',
    padding: '$2 $4',
    borderRadius: '$small',
    span: {
      textTransform: 'unset',
    },
  }),

  TableCell: styled(Table.Cell, {
    padding: '$4',
    whiteSpace: 'unset',
  }),

  TableCellVerticalAlignUnset: styled(Table.Cell, {
    padding: '$4',
    whiteSpace: 'unset',
    verticalAlign: 'unset',
  }),

  ProductName: styled(ResponsiveFloraTypography, {
    maxWidth: '270px',
    wordBreak: 'break-all',
    whiteSpace: 'normal',
  }),
};
